import React, { useState } from 'react';
import axios from 'axios';
import './Contact.css';

function Contact() {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    subject: '',
    category: 'general',
    message: ''
  });
  const [loading, setLoading] = useState(false);
  const [submitted, setSubmitted] = useState(false);
  const [error, setError] = useState('');

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');

    try {
      const response = await axios.post('http://localhost:5001/api/forms/inquiry', formData);
      setSubmitted(true);
      setFormData({
        name: '',
        email: '',
        phone: '',
        subject: '',
        category: 'general',
        message: ''
      });
    } catch (err) {
      setError(err.response?.data?.message || 'Σφάλμα κατά την αποστολή του μηνύματος');
    } finally {
      setLoading(false);
    }
  };

  if (submitted) {
    return (
      <div className="contact-page">
        <div className="success-message-container">
          <div className="success-icon">✉️</div>
          <h1>Το Μήνυμά σας Στάλθηκε Επιτυχώς!</h1>
          <p>Ευχαριστούμε που επικοινωνήσατε μαζί μας.</p>
          <p>Θα απαντήσουμε στο email σας το συντομότερο δυνατόν.</p>
          <button 
            className="btn btn-primary"
            onClick={() => setSubmitted(false)}
          >
            Αποστολή Νέου Μηνύματος
          </button>
        </div>
      </div>
    );
  }

  return (
    <div className="contact-page">
      <div className="contact-hero">
        <div className="container">
          <h1 className="contact-title">Επικοινωνήστε Μαζί Μας</h1>
          <p className="contact-subtitle">
            Έχετε ερωτήσεις; Θέλετε να μάθετε περισσότερα; Στείλτε μας μήνυμα!
          </p>
        </div>
      </div>

      <div className="container">
        <div className="contact-content">
          <div className="contact-info-section">
            <h2>Πληροφορίες Επικοινωνίας</h2>
            
            <div className="info-cards">
              <div className="info-card">
                <div className="info-icon">📧</div>
                <h3>Email</h3>
                <p>info@freelancher.gr</p>
                <p>support@freelancher.gr</p>
              </div>

              <div className="info-card">
                <div className="info-icon">📱</div>
                <h3>Τηλέφωνο</h3>
                <p>+30 210 123 4567</p>
                <p>Δευτέρα - Παρασκευή: 9:00 - 18:00</p>
              </div>

              <div className="info-card">
                <div className="info-icon">📍</div>
                <h3>Διεύθυνση</h3>
                <p>Πανεπιστημίου 42</p>
                <p>Αθήνα, 10679</p>
              </div>

              <div className="info-card">
                <div className="info-icon">💬</div>
                <h3>Social Media</h3>
                <div className="social-links">
                  <a href="#" className="social-link">Facebook</a>
                  <a href="#" className="social-link">LinkedIn</a>
                  <a href="#" className="social-link">Twitter</a>
                </div>
              </div>
            </div>

            <div className="faq-quick">
              <h3>Συχνές Ερωτήσεις</h3>
              <div className="faq-item">
                <strong>Πώς μπορώ να βρω freelancer;</strong>
                <p>Περιηγηθείτε στις κατηγορίες υπηρεσιών και επιλέξτε την που σας ενδιαφέρει.</p>
              </div>
              <div className="faq-item">
                <strong>Πόσο χρόνο χρειάζεται για απάντηση;</strong>
                <p>Συνήθως απαντάμε εντός 24 ωρών σε εργάσιμες ημέρες.</p>
              </div>
            </div>
          </div>

          <div className="contact-form-section">
            <h2>Στείλτε μας Μήνυμα</h2>
            
            {error && (
              <div className="error-message">
                <span className="error-icon">⚠️</span>
                {error}
              </div>
            )}

            <form onSubmit={handleSubmit} className="contact-form">
              <div className="form-row">
                <div className="form-group">
                  <label htmlFor="name">Ονοματεπώνυμο *</label>
                  <input
                    type="text"
                    id="name"
                    name="name"
                    value={formData.name}
                    onChange={handleChange}
                    required
                    placeholder="π.χ. Μαρία Παπαδοπούλου"
                  />
                </div>

                <div className="form-group">
                  <label htmlFor="email">Email *</label>
                  <input
                    type="email"
                    id="email"
                    name="email"
                    value={formData.email}
                    onChange={handleChange}
                    required
                    placeholder="your.email@example.com"
                  />
                </div>
              </div>

              <div className="form-row">
                <div className="form-group">
                  <label htmlFor="phone">Τηλέφωνο</label>
                  <input
                    type="tel"
                    id="phone"
                    name="phone"
                    value={formData.phone}
                    onChange={handleChange}
                    placeholder="69XXXXXXXX"
                  />
                </div>

                <div className="form-group">
                  <label htmlFor="category">Κατηγορία *</label>
                  <select
                    id="category"
                    name="category"
                    value={formData.category}
                    onChange={handleChange}
                    required
                  >
                    <option value="general">Γενική Πληροφόρηση</option>
                    <option value="support">Τεχνική Υποστήριξη</option>
                    <option value="partnership">Συνεργασία</option>
                    <option value="billing">Οικονομικά</option>
                    <option value="other">Άλλο</option>
                  </select>
                </div>
              </div>

              <div className="form-group">
                <label htmlFor="subject">Θέμα *</label>
                <input
                  type="text"
                  id="subject"
                  name="subject"
                  value={formData.subject}
                  onChange={handleChange}
                  required
                  placeholder="Πες μας συνοπτικά το θέμα σου"
                />
              </div>

              <div className="form-group">
                <label htmlFor="message">Μήνυμα *</label>
                <textarea
                  id="message"
                  name="message"
                  value={formData.message}
                  onChange={handleChange}
                  required
                  rows="6"
                  placeholder="Γράψε το μήνυμά σου εδώ..."
                />
              </div>

              <button 
                type="submit" 
                className="btn btn-primary btn-large btn-submit"
                disabled={loading}
              >
                {loading ? '⏳ Αποστολή...' : '📨 Αποστολή Μηνύματος'}
              </button>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Contact;
